import React from 'react'
import { useSelector } from 'react-redux'
import CoverageBenefits from '../CoverageBenefits'
import { getUserSubscription } from '../../../utils/paymentUtils'
import $t from '../../../i18n'

const CoverageBenefitsByProvider = () => {
  const mySubscriptions = useSelector(state => state?.payment?.my_subscriptions)
  const futureSubscriptions = useSelector(
    state => state?.payment?.future_subscriptions
  )
  const selectedEnrollmentYear = useSelector(
    state => state.payment?.selectedEnrollmentYear
  )

  const subscription = getUserSubscription(
    mySubscriptions,
    futureSubscriptions,
    selectedEnrollmentYear
  )

  return !subscription ? (
    <div className='error-message'>
      {$t('pages.coverageBenefits.infoNotAvailable')}
    </div>
  ) : (
    <CoverageBenefits subscription={subscription} />
  )
}

export default CoverageBenefitsByProvider
